import { CoreApi } from '@inter-ikea-storageone/range';
import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import replaceProductIgnoreStability from 'rangeConfig/bror/behaviors/replaceProductIgnoreStability';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import {
  matchDepth,
  matchWidth,
  matchDimensions,
  matchType
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import ChangeSize from 'rangeConfig/bror/widgets/changeSize/ChangeSize';
import OnlyOneColorMessage from 'rangeConfig/bror/widgets/OnlyOneColorMessage';
import store from 'ducks/configureStore';
import { getMarketProducts } from 'ducks/products';

const availableColorsOfCurrentFrameSize = (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return [];

  const id = coreApi.entities.getProductRef(selectedEntity);
  const productsInMarket = getMarketProducts(store.getState());
  const sectionsInMarket = productsInMarket.filter(p => p.type === ProductType.BROR_SECTION);
  const currentSection = sectionsInMarket.find(s => s.coreProductId === id);
  if (!currentSection) return [];

  const sectionsOfMatchingSize = sectionsInMarket.filter(
    s =>
      s.communicatedDimensions.width === currentSection?.communicatedDimensions.width &&
      s.communicatedDimensions.depth === currentSection?.communicatedDimensions.depth &&
      s.communicatedDimensions.height === currentSection?.communicatedDimensions.height
  );
  const availableColors = sectionsOfMatchingSize.map(s => s.designText);

  return availableColors;
};

const colors = {
  id: 'sections-selected-menu-colors',
  title: 'storageone.colorFilterLabel',
  cardsTitle: '',
  cardsSubtitle: 'typeName',
  behaviors: {
    productClicked: [replaceProductIgnoreStability],
    productDropped: []
  },
  productTypes: [ProductType.BROR_SECTION],
  filters: [],
  productFilters: [matchType, matchDimensions],
  useMLSorting: true,
  hidden: (coreApi: CoreApi) => availableColorsOfCurrentFrameSize(coreApi).length < 2
};

const onlyOneColorMessage = {
  id: 'section-selected-menu-only-one-color',
  title: 'storageone.colorFilterLabel',
  component: OnlyOneColorMessage,
  hidden: (coreApi: CoreApi) => availableColorsOfCurrentFrameSize(coreApi).length >= 2
};

const interiors = {
  id: 'section-selected-menu-interiors',
  title: 'storageone.productListInteriorsTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addToTarget],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.BROR_SHELF_METAL_BLACK,
    ProductType.BROR_SHELF_BLACK_PINE,
    ProductType.BROR_SHELF_GREEN_PINE,
    ProductType.BROR_DRAWER_METAL_BLACK,
    ProductType.BROR_CABINET_BLACK,
    ProductType.BROR_CABINET_GREEN
  ],
  productFilters: [matchWidth, matchDepth]
};

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    {
      id: 'change-size',
      component: ChangeSize
    },
    colors,
    onlyOneColorMessage,
    interiors
  ],
  mobile: [interiors]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseSection',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
